// yes it says emails invitations all over but it's sending push notifications

import React, { useEffect, useState } from 'react';
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Chip,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Spinner,
} from '@nextui-org/react';
import { Tasks } from 'common/src/utils/types';
import { toast } from 'react-toastify';
// import { fetchTaskOffersForTask } from 'common/src/api/taskers';
// import { sendTaskerAssignmentEmail } from 'common/src/api/emails/taskerEmails';
// import { sendTaskerAssignmentSMS, sendAskerAssignmentSMS } from './smsUtils';
import { insertTaskEvent, checkTaskEventExists } from 'common/src/api/task_events';
import { Link } from 'wouter';
// import { createEmailLog } from 'common/src/api/email_logs';
import { fetchBankAccount } from 'common/src/api/bank_accounts';
import { BankAccount } from 'common/src/types/bank_accounts';
// import { FaArrowRight } from 'react-icons/fa';
// import { useLocation } from 'wouter';
import { sendPushNotification } from 'common/src/api/services/mobile_notifications';
import { calculateTaskerEarnings } from 'common/src/utils/calculations';
import { fetchOneAssignedTaskers } from 'common/src/api/assigned-taskers';
import { fetchOneTaskOffers } from 'common/src/api/task_offers';
import { fetchOneAutomatedOffer, fetchOneByTaskIdAutomatedOffers } from 'common/src/api/automated-offers';
import { fetchByCategory } from 'common/src/api/taskers';

interface RightColumnProps {
  task: Tasks;
  category: { id: number; name: string } | null;
  taskers: { id: number; email: string }[];
  isTaskersLoading: boolean;
}
const RightColumn: React.FC<RightColumnProps> = ({ task, category, taskers, isTaskersLoading }) => {
  const [assignedTaskers, setAssignedTaskers] = useState<
    {
      id: number;
      task_id: number;
      tasker_id: number;
      tasker: {
        id: number;
        name: string;
        last_name: string;
        email: string;
        phone_number: string;
        university: string;
        career: string;
        carreer: string;
        university_year: number;
        auth_id: string;
      };
    }[]
  >([]);
  const [emailsSent, setEmailsSent] = useState(false);
  const [selectedBankAccount, setSelectedBankAccount] = useState<BankAccount | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const [, setLocation] = useLocation();
  const [, setTaskOffers] = useState<
    {
      id: number;
      task_id: number;
      tasker_id: number;
      status: string;
      tasker: {
        id: number;
        name: string;
        last_name: string;
        email: string;
        phone_number: string;
        university: string;
        career: string;
        carreer: string;
        university_year: number;
        auth_id: string;
      };
    }[]
  >([]);
  const [appliedTaskers, setAppliedTaskers] = useState([]);

  useEffect(() => {
    const loadAssignedTaskers = async () => {
      try {
        const { data, error } = await fetchOneAssignedTaskers(task.id);
        if (error) throw error;
        setAssignedTaskers(data || []);
      } catch (error) {
        console.error('Error loading assigned taskers:', error);
        setAssignedTaskers([]);
      }
    };

    const checkEmailsSent = async () => {
      try {
        const sent = await checkTaskEventExists({
          taskId: task.id,
          eventName: 'tasker-invitation-emails-sent',
        });
        setEmailsSent(sent);
      } catch (error) {
        console.error('Error checking if emails were sent:', error);
      }
    };

    const loadTaskOffers = async () => {
      try {
        const { data: offers, error } = await fetchOneTaskOffers(task.id)
        if (error) throw error;
        setTaskOffers(offers || []);
      } catch (error) {
        console.error('Error fetching task offers:', error);
        toast.error('Error loading task offers');
      }
    };

    const loadAppliedOffers = async () => {
      try {
        const { data: automatedTaskOffer } = await fetchOneByTaskIdAutomatedOffers(task.id)

        if (!automatedTaskOffer) {
          setAppliedTaskers([]);
          return;
        }

        const { data: offersData } = await fetchOneAutomatedOffer(automatedTaskOffer.id)

        setAppliedTaskers(offersData || []);
      } catch (error) {
        console.error('Error loading applied offers:', error);
        setAppliedTaskers([]);
      }
    };

    loadAssignedTaskers();
    checkEmailsSent();
    loadTaskOffers();
    loadAppliedOffers();
  }, [task.id]);

  const handleSendEmails = async () => {
    console.log('Starting to send email invitations...');
    try {
      toast.loading('Enviando invitaciones...');

      // Verificar que los taskers tengan la categoría correcta
      const { data: taskersData, error: taskersError } = await fetchByCategory(taskers.map((tasker) => tasker.id), category?.id)
      if (taskersError) {
        throw new Error('Error obteniendo datos de los taskers');
      }

      const earnings = await calculateTaskerEarnings(task.id);

      // Continuar con el envío de notificaciones solo a los taskers verificados
      const notificationPromises = taskersData
        .filter((tasker) => tasker.auth_id)
        .map((tasker) =>
          sendPushNotification(
            tasker.auth_id,
            `Gana: $${earnings.toLocaleString('es-CL')}`,
            `Task de ${task.category} que podría interesarte.`,
            {
              type: 'new_task_invitation',
              taskId: task.id,
              category: task.category,
              price: earnings,
            }
          )
        );

      await Promise.all(notificationPromises);

      // Registrar el evento
      await insertTaskEvent({
        taskId: task.id,
        eventName: 'tasker-invitation-emails-sent',
      });

      setEmailsSent(true);
      toast.dismiss();
      toast.success('Invitaciones enviadas exitosamente');
    } catch (error) {
      console.error('Error sending invitations:', error);
      toast.dismiss();
      toast.error('Error al enviar invitaciones');
    }
  };

  // const asignarTasker = async (taskerId: number) => {
  //   toast.loading('Asignando tasker...');
  //   try {
  //     // Insertar en assigned_taskers
  //     const { error: assignError } = await supabase
  //       .from('assigned_taskers')
  //       .insert([{ task_id: task.id, tasker_id: taskerId }]);

  //     if (assignError) throw assignError;

  //     // Actualizar el estado de la task
  //     await supabase
  //       .from('tasks')
  //       .update({ tasker_id: taskerId })
  //       .eq('id', task.id);

  //     // Fetch the assigned tasker's data
  //     const { data: taskerData, error: taskerError } = await supabase
  //       .from('taskers')
  //       .select('*')
  //       .eq('id', taskerId)
  //       .single();

  //     if (taskerError) throw taskerError;

  //     // Send email and SMS to the assigned tasker
  //     try {
  //       console.log('### task: ', task);
  //       await sendTaskerAssignmentEmail({ task, tasker: taskerData });
  //       // Add email log
  //       await createEmailLog({
  //         recipient_email: taskerData.email,
  //         sender_email: 'soporte@taskyapp.cl',
  //         label: 'tasker-assigned',
  //         status: 'success',
  //         task_id: task.id,
  //       });
  //     } catch (error) {
  //       console.error('Error sending email to tasker:', error);
  //       toast.error('Error al enviar correo electrónico al tasker');
  //       // Log failed email attempt
  //       await createEmailLog({
  //         recipient_email: taskerData.email,
  //         sender_email: 'soporte@taskyapp.cl',
  //         label: 'tasker-assigned',
  //         status: 'failure',
  //         task_id: task.id,
  //       });
  //     }

  //     try {
  //       await sendTaskerAssignmentSMS(task, taskerData);
  //     } catch (error) {
  //       console.error('Error sending SMS to tasker:', error);
  //       toast.error('Error al enviar SMS al tasker');
  //     }

  //     // Send SMS to the asker
  //     try {
  //       await sendAskerAssignmentSMS(task, taskerData);
  //     } catch (error) {
  //       console.error('Error sending SMS to asker:', error);
  //       toast.error('Error al enviar SMS al asker');
  //     }

  //     toast.dismiss();
  //     toast.success('Tasker asignado exitosamente');
  //     await loadAssignedTaskers();
  //   } catch (error) {
  //     toast.dismiss();
  //     console.error('Error al asignar tasker:', error);
  //     toast.error('Error al asignar tasker');
  //   }
  // };

  // const deAsignarTasker = async (taskerId: number) => {
  //   toast.loading('De-asignando tasker...');
  //   try {
  //     // Eliminar de assigned_taskers
  //     await supabase
  //       .from('assigned_taskers')
  //       .delete()
  //       .eq('task_id', task.id)
  //       .eq('tasker_id', taskerId);

  //     // Actualizar el estado de la task
  //     await supabase
  //       .from('tasks')
  //       .update({ tasker_id: null })
  //       .eq('id', task.id);

  //     toast.dismiss();
  //     toast.success('Tasker de-asignado exitosamente');
  //     await loadAssignedTaskers();
  //   } catch (error) {
  //     toast.dismiss();
  //     console.error('Error al de-asignar tasker:', error);
  //     toast.error('Error al de-asignar tasker');
  //   }
  // };

  // const refreshTaskOffers = async () => {
  //   const { data: offers, error } = await supabase
  //     .from('task_offers')
  //     .select(
  //       `
  //       *,
  //       tasker:tasker_id (*)
  //     `
  //     )
  //     .eq('task_id', task.id);

  //   if (error) throw error;
  //   setAssignedTaskers(offers || []);
  // };

  const handleViewBankAccount = async (taskerId: number) => {
    try {
      const bankAccount = await fetchBankAccount(taskerId);
      setSelectedBankAccount(bankAccount);
      onOpen();
    } catch (error) {
      console.error('Error fetching bank account:', error);
      toast.error('Error al obtener datos bancarios');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gray-100 rounded-xl p-5">
        <div className=" mb-2">
          {emailsSent && (
            <Chip color="success" variant="flat">
              Push enviados
            </Chip>
          )}
          <h3 className="text-md font-semibold">Enviar invitación a Taskers</h3>
        </div>
        <div className="flex space-x-4">
          <Button
            color="primary"
            onClick={handleSendEmails}
            disabled={!category || taskers.length === 0 || isTaskersLoading}
            endContent={isTaskersLoading && <Spinner size="sm" color="white" />}
          >
            {isTaskersLoading ? 'Cargando taskers...' : `Enviar Push (${taskers.length})`}
          </Button>
        </div>
      </div>

      <div className="bg-gray-100 rounded-xl p-5">
        <h3 className="text-md font-semibold mb-2">Foto de Task Completado</h3>
        {task.task_completed_proof_url ? (
          <img
            src={task.task_completed_proof_url}
            alt="Prueba de task completado"
            className="w-full max-w-md h-64 object-cover rounded-lg"
          />
        ) : (
          <div className="w-full max-w-md h-64 bg-gray-200 rounded-lg flex items-center justify-center text-gray-500">
            Todavía no hay una foto del task completado
          </div>
        )}
      </div>

      <div>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-md font-semibold">Taskers Postulados</h3>
          <Button
            as={Link}
            href={`/tasks/${task.id}/postulations`}
            size="sm"
            color="primary"
            variant="flat"
          >
            Ver todas las postulaciones
          </Button>
        </div>

        <Table aria-label="Applied Offers">
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>Apellido</TableColumn>
            <TableColumn>Universidad</TableColumn>
            <TableColumn>Carrera</TableColumn>
            <TableColumn>Año universitario</TableColumn>
            <TableColumn>Email</TableColumn>
            <TableColumn>Contacto</TableColumn>
            <TableColumn>Datos Bancarios</TableColumn>
          </TableHeader>
          <TableBody>
            {appliedTaskers.map((offer) => (
              <TableRow key={offer.id}>
                <TableCell>
                  <Link href={`/tasker/${offer.tasker.id}`}>
                    <a
                      className="text-blue-600 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {offer.tasker.name}
                    </a>
                  </Link>
                </TableCell>
                <TableCell>{offer.tasker.last_name}</TableCell>
                <TableCell>{offer.tasker.university}</TableCell>
                <TableCell>{offer.tasker.career || offer.tasker.carreer}</TableCell>
                <TableCell>{offer.tasker.university_year}</TableCell>
                <TableCell>{offer.tasker.email}</TableCell>
                <TableCell>
                  <Button
                    size="sm"
                    color="success"
                    as="a"
                    href={`https://wa.me/${offer.tasker.phone_number}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    size="sm"
                    color="secondary"
                    onClick={() => handleViewBankAccount(offer.tasker.id)}
                  >
                    Ver datos bancarios
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-md font-semibold">Taskers Asignados</h3>
          <Button
            as={Link}
            href={`/tasks/${task.id}/postulations`}
            size="sm"
            color="primary"
            variant="flat"
          >
            Ver todas las postulaciones
          </Button>
        </div>

        <Table aria-label="All Offers">
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>Apellido</TableColumn>
            <TableColumn>Universidad</TableColumn>
            <TableColumn>Carrera</TableColumn>
            <TableColumn>Año universitario</TableColumn>
            <TableColumn>Email</TableColumn>
            <TableColumn>Contacto</TableColumn>
            <TableColumn>Datos Bancarios</TableColumn>
          </TableHeader>
          <TableBody>
            {assignedTaskers.map((offer) => (
              <TableRow key={offer.id}>
                <TableCell>
                  <Link href={`/tasker/${offer.tasker_id}`}>
                    <a
                      className="text-blue-600 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {offer.tasker.name}
                    </a>
                  </Link>
                </TableCell>
                <TableCell>{offer.tasker.last_name}</TableCell>
                <TableCell>{offer.tasker.university}</TableCell>
                <TableCell>{offer.tasker.career || offer.tasker.carreer}</TableCell>
                <TableCell>{offer.tasker.university_year}</TableCell>
                <TableCell>{offer.tasker.email}</TableCell>
                <TableCell>
                  <Button
                    size="sm"
                    color="success"
                    as="a"
                    href={`https://wa.me/${offer.tasker.phone_number}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    size="sm"
                    color="secondary"
                    onClick={() => handleViewBankAccount(offer.tasker_id)}
                  >
                    Ver datos bancarios
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <ModalHeader>Datos Bancarios</ModalHeader>
          <ModalBody>
            {selectedBankAccount ? (
              <div>
                <p>
                  <strong>Nombre:</strong> {selectedBankAccount.name}
                </p>
                <p>
                  <strong>Banco:</strong> {selectedBankAccount.bank}
                </p>
                <p>
                  <strong>Tipo de cuenta:</strong> {selectedBankAccount.account_type}
                </p>
                <p>
                  <strong>Número de cuenta:</strong> {selectedBankAccount.account_number}
                </p>
                <p>
                  <strong>RUT:</strong> {selectedBankAccount.rut}
                </p>
              </div>
            ) : (
              <p>No se encontraron datos bancarios para este tasker.</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={onClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default RightColumn;
